module.exports = __webpack_public_path__ + "static/media/obcasy.8eef6baa.jpg";